import type {PartData, ComponentProps} from '@enonic/react-components';
import * as React from 'react';
import ProductListing, {Product} from '../components/ProductListing';


export interface FeaturedListingsProps
	extends Record<string, unknown> {
	heading?: string
	listings?: Product[]
	viewAllPage: string // href
}

export const FeaturedListings = ({data}: ComponentProps<PartData>) => {

	const {
		heading,
		listings,
		viewAllPage,
	} = data as FeaturedListingsProps;

	return <section className="featured-listings">
		{heading && viewAllPage && (
			<header className="featured-listings__header">
				<a className="featured-listings__view-all-link" href={viewAllPage}>
					<h2 className="featured-listings__heading">{heading}</h2>
					<span className="featured-listings__view-all">{`View all ${heading}`}</span>
				</a>
			</header>
		)}
		{listings && <ProductListing products={listings}/>}
	</section>
};
FeaturedListings.displayName = 'FeaturedListings';
